import React from "react";
import data from "../../json/Allproducts/Allproducts.json";
import { Link } from "react-router-dom";
const Section2 = ({ data }) => {
  return (
    <div className="w-full hidden  md:flex justify-center">
      <div className="2xl:container flex flex-col px-6 py-16 md:py-[72px] md:px-10 lg:px-20 ">
        <h1 className="text-24  sm:text-32  lg:text-48 text-primarycolor text-center pb-12 sm:pb-16 lg:pb-[72px] font-bold"> {data.Title}</h1>
        <div className="w-full">
          <img src={process.env.PUBLIC_URL + data.img} alt="img" />
        </div>

      </div>
    </div>
  );
};

export default Section2;
